import React, { useEffect, useState } from "react";
import API from "../Service/Baseservice";
import "./Newspreview.css";

const Newspreview = ({ previewNews }) => {
    const [newsList, setNewsList] = useState([]);
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);
    const rowsPerPage = 9;
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchNews();
    }, [page]);

    const fetchNews = () => {
        setLoading(true);
        API.post("news_list/condition", {
            search: "",
            status: "active",
            from_date: "",
            to_date: "",
            rowsPerPage,
            page,
        })
            .then((res) => {
                let data = res?.data?.data?.data || [];
                if (previewNews) data = [previewNews, ...data];

                const totalCount = res?.data?.data?.data1?.[0]?.totalcount || data.length;
                setNewsList(data);
                setTotalPages(Math.ceil(totalCount / rowsPerPage));
            })
            .catch((err) => console.error("Failed to fetch news:", err))
            .finally(() => setLoading(false));
    };

    const leftNews = newsList.slice(0, 3);
    const rightNews = newsList.slice(3, 9);
    return (
        <div style={{ overflowX: "hidden" }}>
            <div className="resourcess">
            
                <div className="shadow-sm latestnewscontent aboutus d-block mx-auto col-lg-10 margintopaboutuses">
                    <h1 className="newscontent">News</h1>
                    <div className="d-flex gap-2 mt-4">
                        <p className="aboutushomename">Home</p>
                        <i className="bi bi-chevron-right aboutushomename"></i>
                        <p className="homeaboutuss">News</p>
                    </div>
                </div>

                <div className="d-flex gap-5 alignitemandjustfy latestnewscontents">
                   
                    <div className="lastnews-left">
                        <h1 className="latestnewsinnews">Latest News</h1>

                        {loading ? (
                            <p>Loading news...</p>
                        ) : leftNews.length > 0 ? (
                            leftNews.map((item, index) => (
                                <div
                                    key={item.news_id}
                                    className={`mb-5 ${index === 0 ? "highlight-news" : ""}`}
                                >
                                    <h3 className="mt-4">{item.heading}</h3>
                                    <p className="twenty">{item.date}</p>
                                    <div
                                        className="layers"
                                        dangerouslySetInnerHTML={{
                                            __html: item.description,
                                        }}
                                    ></div>
                                    {index < leftNews.length - 1 && (
                                        <hr className="expressdividers col-lg-12" />
                                    )}
                                </div>
                            ))
                        ) : (
                            <p>No news found.</p>
                        )}
                    </div>

                    
                    <div className="lastnews-right">
                        <div className="search-box">
                            <h5 className="search-title">Search Here</h5>
                            <hr className="expressdividers col-lg-12" />
                            <div className="form-outline position-relative mt-2 w-90">
                                <input
                                    id="search-input"
                                    placeholder="Search.."
                                    className="search-input"
                                />
                                <i
                                    className="fas fa-search position-absolute"
                                    style={{
                                        right: "17px",
                                        top: "28%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                            </div>
                        </div>

                        <div className="more-news-box mt-3">
                            <h5>More News</h5>

                            {loading ? (
                                <p>Loading...</p>
                            ) : rightNews.length > 0 ? (
                                rightNews.map((n) => (
                                    <div key={n.news_id}>
                                        <h6 className="mt-4">{n.heading}</h6>
                                        <div
                                            className="chinacalled"
                                            dangerouslySetInnerHTML={{
                                                __html: n.description?.length > 100
                                                    ? n.description.substring(0, 100) + "..."
                                                    : n.description,
                                            }}
                                        ></div>

                                        <p className="mt-2 datesize">{n.date}</p>
                                        <hr className="expressdividers col-lg-12" />
                                    </div>
                                ))
                            ) : (
                                <p>No more news found.</p>
                            )}


                        </div>
                    
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Newspreview;


